import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkdownModule } from 'ngx-markdown';
import { SharedModule } from '../shared/shared.module';

import { HomeRoutingModule } from './home-routing.module';

import { HomeFanComponent } from './home-fan/home-fan.component';
import { HomeOrgaComponent } from './home-orga/home-orga.component';
import { ContactComponent } from './contact/contact.component';
import { FaqComponent } from './faq/faq.component';
import { TermsComponent } from './terms/terms.component';
import { PartnersComponent } from './components/partners/partners.component';
import { FanReasonsComponent } from './components/fan-reasons/fan-reasons.component';
import { DemoComponent } from './demo/demo.component';
import { NewsletterFormComponent } from './components/newsletter-form/newsletter-form.component';
import { PhoneModule } from '../shared/phone.module';

@NgModule({
  providers: [],
  imports: [
    CommonModule,
    HomeRoutingModule,
    SharedModule,
    PhoneModule,
    MarkdownModule.forRoot(),
    HomeFanComponent,
    HomeOrgaComponent,
    ContactComponent,
    FaqComponent,
    TermsComponent,
    PartnersComponent,
    FanReasonsComponent,
    DemoComponent,
    NewsletterFormComponent,
  ],
})
export class HomeModule { }
